import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import Links from 'ui/components/generic/Links'
import YouTube from 'react-youtube'
import theme from 'ui/styles/theme'

export default class FixedImageAndText extends Component {
  state = {
    youtubeVisible: false
  }

  toggleYoutube = () => {
    const { youtubeVisible } = this.state

    this.setState({ youtubeVisible: !youtubeVisible })
  }

  render() {
    const { header, body, buttons, image, orientation, youtube, video, bgcolor } = this.props
    const { youtubeVisible } = this.state

    return (
      <Wrapper bgcolor={bgcolor}>
        <Container fluid>
          <StyledRow>
            <Col
              md={4}
              mdOffset={1}
              order={orientation === 'left' ? 2 : 1}
            >
              <TextCol>
                <Header>{header}</Header>
                <Text dangerouslySetInnerHTML={{ __html: body }} />
                <Links links={buttons} color="primary" />
              </TextCol>
            </Col>
            <StyledCol
              md={6}
              mdOffset={orientation === 'left' ? 0 : 1}
              alignSelf="stretch"
              order={orientation === 'left' ? 1 : 2}
              orientation={orientation}
            >
              {youtube && (
                <PlayButton onClick={this.toggleYoutube}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="15"
                    viewBox="0 0 12 15"
                  >
                    <path fill="#FFF" fillRule="evenodd" d="M12.025 7.4L0 14.8V0z"></path>
                  </svg>
                </PlayButton>
              )}
              {video ? (
                <Video src={video.sourceUrl} muted autoPlay loop />
              ) : (
                <Image image={image.sourceUrl} />
              )}
            </StyledCol>
          </StyledRow>
        </Container>

        {youtubeVisible && (
          <YouTubeOverlay onClick={this.toggleYoutube}>
            <YouTube
              videoId={youtube}
              opts={{
                playerVars: {
                  autoplay: 1,
                }
              }}
            />
          </YouTubeOverlay>
        )}
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin-bottom: 30px;
  background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
  ${media.lg`
    margin: 50px 0 70px;
  `}
`

const StyledRow = styled(Row)`

`
const StyledCol = styled(Col)`
  display: flex;
  align-items: center;
  
  ${media.sm`
    ${props => props.orientation === 'left' ? `
      padding-left: 0;
    ` : `
      padding-right: 0;
    `};
  `}
`

const Text = styled.div`
  margin-bottom: 30px;
  font-weight: 300;
  font-size: 20px;
  line-height: 22px;
  word-break: break-word;
  color: ${props => props.theme.colors.text};
`

const Header = Text.extend`
  border-top: 1px solid black;
  padding-top: 30px;
  color: ${props => props.theme.colors.tones.dark};
  font-size: 40px;
  line-height: normal;
`

const TextCol = styled.div`
  position: relative;
  margin-bottom: 30px;

  ${media.lg`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 0;
    padding: 4rem 0;
    min-height: 40vw;
  `}
`

const Image = styled.div`
  background: url(${props => props.image}) center / cover;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;

  ${media.md`
    width: 100%;
  `}
`

const PlayButton = styled.button`
  width: 74px;
  height: 74px;
  border-radius: 100%;
  background: ${props => props.theme.colors.primary};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;

  &:hover {
    cursor: pointer;
  }
`

const YouTubeOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;

  div {
    width: 80%;
    height: 0;
    padding-bottom: 45%;
    position: relative;
  }

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

const Video = styled.video`
  width: 100%;
  object-fit: cover;
`



// WEBPACK FOOTER //
// ./src/ui/components/modules/FixedImageAndText/index.js